import { useQuery } from "@tanstack/react-query";
import { SingleSelectDropdown } from "Components/SingleSelectDropdown";
import apiClient from "QueryClient/axiosClient";
import { Flex, Typography } from "antd";
import debounce from "lodash.debounce";
import { useMemo, useState } from "react";

const fetchCourses = async ({ queryKey }) => {
  const [, search] = queryKey;
  const response = await apiClient.get("/courses", {
    params: { q: search },
  });
  return response.data;
};

export const Branch = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  const [search, setSearch] = useState("");
  const { data, error, isLoading } = useQuery({
    queryKey: ["/courses", search],
    queryFn: fetchCourses,
  });
  const debounceSearch = debounce((value) => {
    setSearch(value);
  }, 500);

  const options = useMemo(() => {
    return isLoading || error
      ? [{ label: "loading", value: "loading" }]
      : data?.data?.map((course) => ({
          label: course.courseName,
          value: course.id,
        }));
  }, [data, isLoading, error]);
  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      style={{ marginTop: "24px" }}
    >
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>Major</Title>
      <SingleSelectDropdown
        options={options}
        placeholder="Select major"
        loading={isLoading}
        onChange={(value) => {
          setSelectedCard(value);
        }}
        value={options.find((option) => option?.value === selectedCard)?.label}
        onSearch={debounceSearch}
      />
    </Flex>
  );
};
